<template>
  <v-container grid-list-xl>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <v-alert :value="alert" type="success">Başarıyla kaldedildi.</v-alert>
      </v-flex>
      <v-flex xs12 md12>
        <v-flex xs12 md12>
          <v-switch
            v-model="discount.isAllProduct"
            @change="changeAllProduct"
            :label="`Ürünlerin Hepsini Seç: ${setState(discount.isAllProduct)}`"
          ></v-switch>
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <v-combobox
          v-model="select"
          :items="this.$store.getters['products/productCategories']"
          item-value="id"
          multiple
          @change="changeProduct"
          item-text="name"
          hide-details
          label="Ürün Seçiniz"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md12>
        <v-text-field
          v-model="discount.discountRate"
          label="Komisyon Oranı"
          :counter="max"
          required
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.startDate"
              label="Başlangıç Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="discount.startDate"
            @input="menu2 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu3"
          v-model="menu3"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.startTime"
              label="Başlangıç Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu3"
            v-model="discount.startTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu3.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.endDate"
              label="Bitiş Tarihi"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="discount.endDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md6>
        <v-menu
          ref="menu4"
          v-model="menu4"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="time"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="discount.endTime"
              label="Bitiş Saati"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="menu4"
            v-model="discount.endTime"
            full-width
            format="24hr"
            @click:minute="$refs.menu4.save(time)"
          ></v-time-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 md2>
        <v-checkbox v-model="discount.monday" :label="`Pazartesi`"></v-checkbox>
      </v-flex>
      <v-flex xs12 md2>
        <v-checkbox v-model="discount.tuesday" :label="`Salı`"></v-checkbox>
      </v-flex>

      <v-flex xs12 md2>
        <v-checkbox
          v-model="discount.wednesday"
          :label="`Çarşamba`"
        ></v-checkbox>
      </v-flex>

      <v-flex xs12 md2>
        <v-checkbox
          v-model="discount.thursday"
          :label="`Perşembe`"
        ></v-checkbox>
      </v-flex>

      <v-flex xs12 md1>
        <v-checkbox v-model="discount.friday" :label="`Cuma`"></v-checkbox>
      </v-flex>

      <v-flex xs12 md2>
        <v-checkbox
          v-model="discount.saturday"
          :label="`Cumartesi`"
        ></v-checkbox>
      </v-flex>

      <v-flex xs12 md1>
        <v-checkbox v-model="discount.sunday" :label="`Pazar`"></v-checkbox>
      </v-flex>

      <v-flex xs12 md12>
        <v-switch
          v-model="discount.state"
          :label="`Komisyon Durumu: ${setState(discount.state)}`"
        ></v-switch>
      </v-flex>
      <v-btn color="success" @click="savediscount">Kaydet</v-btn>
    </v-layout>
  </v-container>
</template>
<script>

export default {
  data: () => ({
    products: [],
    alert: false,
    allowSpaces: false,
    match: "Foobar",
    max: 0,
    select: [],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    menu1: false,
    time: null,
    menu2: false,
    menu3: false,
    menu4: false,
    model: "Foobar",
    discount: {
      state: true,
    },
  }),

  watch: {},

  methods: {
    changeProduct() {
      this.discount.isAllProduct = false;
    },
    changeAllProduct(categoryids) {
      if (categoryids) {
        this.select = this.$store.getters["products/productCategories"];
      } else {
        this.select = [];
      }
    },
    setState(state) {
      if (state) return "Aktif";
      return "Pasif";
    },
    async savediscount() {
      this.discount.discountRate = this.discount.discountRate;
      let discount = Object.assign({}, this.discount);
      discount.productIds = this.select.map((m) => m.id).join(",");
      if (this.discount.id)
        this.$store.dispatch("discounts/putDiscount", discount);
      else this.$store.dispatch("discounts/postDiscount", discount);
      this.alert = true;
    },
    validateField() {
      this.$refs.form.validate();
    },
    resetValidation() {
      //   this.$refs.form.validate();
    },
  },
  computed: {},
  async mounted() {
    if (this.$route.params.id) {
      await this.$store.dispatch(
        "discounts/getDiscount",
        this.$route.params.id
      );
      this.discount = this.$store.state.discounts.discount;
      this.discount.startDate = this.discount.startDate.substr(0, 10);
      this.discount.endDate = this.discount.endDate.substr(0, 10);
      this.discount.startTime = this.discount.startTime.substr(0, 5);
      this.discount.endTime = this.discount.endTime.substr(0, 5);
    }

    await this.$store.dispatch("products/getAllProducts");

    if (this.discount.productIds) {
      var ids = this.discount.productIds.split(",").map(Number);
      this.select = this.$store.getters["products/productCategories"].filter(
        (x) => ids.includes(x.id)
      );
    }
  },
};
</script>
